import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Grid,
  Paper,
  Button,
  Typography,
} from '@material-ui/core';
import {
  Search as SearchIcon,
  PlayForWork as PlayForWorkIcon,
} from '@material-ui/icons';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { withContext } from 'common/helpers/context';
import CustomSelect from 'common/components/CustomSelect';
import { useCommonStyles } from 'common/common.style';
import { useStyles } from './SearchBar.style';
import LoadPositionModal from '../LoadPositionModal/LoadPositionModal';

const mapValues = (e) => ({
  label: e.name,
  value: e.id,
});

const SearchBar = (props) => {
  const classesCommon = useCommonStyles();
  const classes = useStyles();

  const formikRef = useRef();
  const [showLoadPosition, setShowLoadPosition] = useState(false);

  const {
    roleId,
    setRoleId,
    disciplineId,
    setDisciplineId,
    options,
    handleClickSearch,
  } = props;
  const { roles, disciplines } = options;

  const OPTIONS_ROLE = roles.map(mapValues);
  const OPTIONS_DISCIPLINE = disciplines
    .filter((discipline) => ![1, 2].includes(discipline.id))
    .map(mapValues);

  useEffect(() => {
    if (roles.length > 0 && disciplines.length > 0) {
      formikRef.current.setFieldValue('roleId', roleId);
      formikRef.current.setFieldValue('disciplineId', disciplineId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roleId, roles, disciplineId, disciplines]);

  const handleClickLoadPosition = () => {
    setShowLoadPosition(true);
  };

  const handleCloseLoadPosition = () => {
    setShowLoadPosition(false);
  };

  return (
    <Grid item xs={12}>
      <Paper className={classesCommon.paper}>
        <Formik
          innerRef={formikRef}
          initialValues={{
            roleId: '',
            disciplineId: '',
          }}
          onSubmit={handleClickSearch}
          validationSchema={Yup.object().shape({
            roleId: Yup.number().required('Required'),
            disciplineId: Yup.number().required('Required'),
          })}
        >
          {(p) => {
            const {
              values,
              touched,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
            } = p;

            const handleChangeToPass = (id) => (event) => {
              if (id === 'roleId') setRoleId(event.target.value);
              if (id === 'disciplineId') setDisciplineId(event.target.value);
              handleChange(id, event);
            };

            const propsToPass = {
              values,
              touched,
              errors,
              handleChange: handleChangeToPass,
              handleBlur,
            };
            const disableSearch =
              values.roleId === 0 || values.disciplineId === 0;

            return (
              <form onSubmit={handleSubmit}>
                <Grid container spacing={3} className={classes.container}>
                  <CustomSelect
                    id="roleId"
                    labelText="Role"
                    options={OPTIONS_ROLE}
                    gridSize={4}
                    {...propsToPass}
                  />
                  <CustomSelect
                    id="disciplineId"
                    labelText="Discipline"
                    options={OPTIONS_DISCIPLINE}
                    gridSize={3}
                    {...propsToPass}
                  />
                  <Grid item xs="auto" className={classes.buttonGroup}>
                    <Button
                      variant="contained"
                      type="submit"
                      color="primary"
                      startIcon={<SearchIcon />}
                      className={classes.button}
                      disabled={disableSearch}
                    >
                      Search
                    </Button>
                    <Button
                      variant="contained"
                      type="button"
                      color="primary"
                      startIcon={<PlayForWorkIcon />}
                      className={classes.button}
                      disabled={disableSearch}
                      onClick={handleClickLoadPosition}
                    >
                      Load Position
                    </Button>
                  </Grid>
                </Grid>
              </form>
            );
          }}
        </Formik>
      </Paper>
      <LoadPositionModal
        open={showLoadPosition}
        handleClose={handleCloseLoadPosition}
      />
    </Grid>
  );
};

SearchBar.propTypes = {
  userInfo: PropTypes.object.isRequired,
  options: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  userInfo: state.dashboard.userInfo,
  options: state.options,
});

export default connect(mapStateToProps)(withContext(SearchBar));
